export default __webpack_public_path__ + "static/media/auth-image.e1185d65.jpg";